import React, { useEffect, useCallback, useState } from "react";
import {
  Box,
  Grid,
  Card,
  CardContent,
  Button,
  TextField,
  IconButton,
  Divider,
  Select,
  MenuItem,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import LabelTypography from "../../components/Typography/LabelTypography";
import Indexdasboard from "../../components/dashboard/IndexDashbord";
import TitreGraphik from "../../components/Typography/TitreGraphik";
import { Api_Token } from "../../util/Api";
import DeleteIcon from "@mui/icons-material/Delete";
import AddBookingsPopup from "../../components/popup/AddBookings";
import Add from "@mui/icons-material/Add";
import NumericFormatEnv from "../../components/Numeric/NumericFormatEnv";
import { useTranslation } from "react-i18next";
import ImageUpload from "../../components/Image/ImageUpload";
import { useAlertContext } from "../../services/AlertServices";

export default function PageTransaction() {
  return <Indexdasboard Children={<Transaction />} />;
}

function Transaction() {
  const location = useLocation();
  const { t } = useTranslation();
  const { selectedBookings } = location.state || {};

  const queryParams = new URLSearchParams(location.search);
  const selectedBookingsApp = queryParams.get("selectedBookings")
    ? JSON.parse(queryParams.get("selectedBookings"))
    : null;

  const [totalAmount, setTotalAmount] = useState(0);
  const [paymentMethod, setPaymentMethod] = useState("cash");
  const [cashAmount, setCashAmount] = useState(totalAmount);
  const [change, setChange] = useState(0);
  const [openPopupAdd, setOpenPopupAdd] = useState(false);
  const { showAlert } = useAlertContext();
  const navigate = useNavigate();

  // Update selected bookings
  const [bookings, setBookings] = useState(
    selectedBookings || [selectedBookingsApp]
  );
  const handleCalculateChange = useCallback(() => {
    const changeAmount = cashAmount - totalAmount;
    setChange(changeAmount >= 0 ? changeAmount : 0);
  }, [cashAmount, totalAmount]);
  console.log("bookings selected:", bookings);
  console.debug(bookings)
  useEffect(() => {
    handleCalculateChange();
  }, [handleCalculateChange]);

  const handlePaymentMethodChange = (event) => {
    setPaymentMethod(event.target.value);
  };

  const handleCashAmountChange = (event) => {
    const { value } = event.target;
    // Update state; if the input is empty, set it to an empty string
    setCashAmount(value);
  };

  // Calculate total amount
  React.useEffect(() => {
    if (bookings && bookings.length > 0) {
      const total = bookings.reduce((acc, booking) => {
        const montant = parseFloat(booking.montant_Reste) || 0;
        console.log("Montant Reste:", montant);
        return acc + montant;
      }, 0);

      setTotalAmount(total);
    }
  }, [bookings]);

  const handleDeleteBooking = (id) => {
    const updatedBookings = bookings.filter((booking) => booking.id !== id);
    setBookings(updatedBookings);
    navigate(null, {
      replace: true,
      state: { selectedBookings: updatedBookings },
    });
  };

  async function onSubmit(e) {
    e.preventDefault();
    const Bookings = bookings.map((b) => (b.id));
    const Data = new FormData(e.target);
    Data.append("montant_total", cashAmount - change);
    Data.append("mode_paiement", paymentMethod);
    Data.append("Bookings", JSON.stringify(Bookings));
    try {
      const response = await Api_Token.post(`transaction/newTransaction`, Data);
      if (response.status === 201) {
        navigate("/bookings");

        showAlert("payment successful", "success");
      }
    } catch (error) {
      const errorMessage = error.response?.data?.error || "Unknown error";
      showAlert(`Error processing payment: ${errorMessage}`, "error");
      console.error("Error processing payment:", errorMessage);
    }
  }

  function AddBookings(bookingsParams) {
    const existingBookingIds = bookings.map((booking) => booking.id);
    const newBookings = bookingsParams.filter(
      (booking) => !existingBookingIds.includes(booking.id)
    );
    setBookings([...bookings, ...newBookings]);
    navigate(null, {
      replace: true,
      state: { selectedBookings: [...bookings, ...newBookings] },
    });
  }

  return (
    <Box>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <TitreGraphik>
            <span onClick={() => navigate(-1)}>⬅</span>
            {t("page Transaction")}
          </TitreGraphik>
        </Grid>
        <Grid item xs={12}>
          <Card sx={{ padding: "2%" }}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <LabelTypography variant="h5">
                    {"Selected Bookings"}
                  </LabelTypography>
                  {/* Delete Button Icon */}
                  <IconButton onClick={() => setOpenPopupAdd(true)}>
                    <Add />
                  </IconButton>
                </Box>
              </Grid>

              {bookings.map((booking) => {
                return (
                  <Grid item xs={12} md={6} key={booking.id}>
                    <Card variant="outlined">
                      <CardContent>
                        <Box
                          display="flex"
                          justifyContent="space-between"
                          alignItems="center"
                        >
                          <LabelTypography>
                            {"ID Booking: #"}
                            {booking.id}
                          </LabelTypography>
                          {/* Delete Button Icon */}
                          <IconButton
                            color="error"
                            onClick={() => handleDeleteBooking(booking.id)}
                          >
                            <DeleteIcon />
                          </IconButton>
                        </Box>
                        <Divider sx={{ margin: "10px 0" }} />
                        <LabelTypography>
                          {t("customers")}
                          {" : "}
                          {booking.client}
                        </LabelTypography>
                        <LabelTypography>
                          {t("Price")}
                          {" : "}
                          <NumericFormatEnv Number={parseFloat(booking.
                            montant_Reste)} />
                        </LabelTypography>
                      </CardContent>
                    </Card>
                  </Grid>
                );
              })}

              <Grid item xs={12}>
                <LabelTypography>
                  {t("Prix Total")} {" : "}
                  <NumericFormatEnv Number={totalAmount} />
                </LabelTypography>
              </Grid>
            </Grid>
          </Card>
        </Grid>
        <Grid item xs={12}>
          {" "}
          <Card sx={{ padding: "2%" }}>
            <form onSubmit={onSubmit}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Select
                    value={paymentMethod}
                    onChange={handlePaymentMethodChange}
                    required
                    fullWidth
                  >
                    <MenuItem value="cash">{t("Cash")}</MenuItem>
                    <MenuItem value="virements">{t("Virements")}</MenuItem>
                    <MenuItem value="check">{t("Chèque")}</MenuItem>
                    <MenuItem value="cart">{t("Cart")}</MenuItem>
                    <MenuItem value="LPO">{t("LPO")}</MenuItem>
                  </Select>
                </Grid>
                {paymentMethod === "cash" && (
                  <>
                    <Grid item xs={12}>
                      <TextField
                        label={t("Montant reçu")}
                        type="number"
                        value={cashAmount === 0 ? "" : cashAmount}
                        onChange={handleCashAmountChange}
                        fullWidth
                        required
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <LabelTypography>
                        {t("Montant total")} {" : "}
                        <NumericFormatEnv Number={totalAmount} />
                      </LabelTypography>
                    </Grid>
                    <Grid item xs={12}>
                      <LabelTypography>
                        {t("Rendu")} {" : "}
                        <NumericFormatEnv Number={change} />
                      </LabelTypography>
                    </Grid>
                  </>
                )}

                {paymentMethod === "check" && (
                  <>
                    <Grid item xs={12}>
                      <TextField
                        label={t("Nom du titulaire")}
                        name="nom"
                        fullWidth
                        required
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        label={t("Numéro du chèque")}
                        name="numero_cheque"
                        fullWidth
                        required
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextField label={t("Banque")} name="banque" fullWidth />
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        label={t("Montant du chèque")}
                        name="montant"
                        type="number"
                        value={cashAmount === 0 ? "" : cashAmount}
                        onChange={handleCashAmountChange}
                        required
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        label={t("Date d'émission")}
                        name="date_emission"
                        type="date"
                        fullWidth
                        InputLabelProps={{
                          shrink: true,
                        }}
                        required
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <ImageUpload />
                    </Grid>
                  </>
                )}
                {paymentMethod === "virements" && (
                  <>
                    <Grid item xs={12}>
                      <TextField
                        label={t("Nom de l'expéditeur")}
                        name="nom_expediteur"
                        fullWidth
                        required
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        label={t("Numéro de transaction")}
                        name="numero_transaction"
                        fullWidth
                        required
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        label={t("Montant du chèque")}
                        name="montant"
                        type="number"
                        value={cashAmount === 0 ? "" : cashAmount}
                        onChange={handleCashAmountChange}
                        required
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        label={t("Banque")}
                        name="banque"
                        fullWidth
                        required
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <ImageUpload />
                    </Grid>
                  </>
                )}
                {paymentMethod === "cart" && (
                  <>
                    <Grid item xs={12}>
                      <TextField
                        label={t("Nom de l'expéditeur")}
                        name="nom_expediteur"
                        fullWidth
                        required
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        label={t("Numéro de transaction")}
                        name="numero_transaction"
                        fullWidth
                      //  required
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        label={t("Montant")}
                        name="montant"
                        type="number"
                        value={cashAmount === 0 ? "" : cashAmount}
                        onChange={handleCashAmountChange}
                        required
                        fullWidth
                      />
                    </Grid>
                  </>
                )}
                {paymentMethod === "LPO" && (
                  <>
                    <Grid item xs={12}>
                      <TextField
                        label={t("Nom de l'expéditeur")}
                        name="nom_expediteur"
                        fullWidth
                        required
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        label={t("Numéro de refernce")}
                        name="numero_ref"
                        fullWidth
                        required
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        label={t("Montant")}
                        name="montant"
                        type="number"
                        value={cashAmount === 0 ? "" : cashAmount}
                        onChange={handleCashAmountChange}
                        required
                        fullWidth
                      />
                    </Grid>
                  </>
                )}
                <Grid item xs={12}>
                  <Button
                    variant="contained"
                    color="primary"
                    type="submit"
                    fullWidth
                    disabled={!paymentMethod}
                  >
                    {t("Confirm Payment")}
                  </Button>
                </Grid>
              </Grid>
            </form>
          </Card>
        </Grid>
      </Grid>
      <AddBookingsPopup
        open={openPopupAdd}
        onClose={() => {
          setOpenPopupAdd(false);
        }}
        AddBookings={AddBookings}
      />
    </Box>
  );
}
